import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { parseAuthFragment } from '../auth/callback';
import { useSession } from '../auth/session';
import { storeTokens } from '../services/refreshAuth';

/** Where sculpt-api lands the Microsoft flow: tokens (or an error) in the fragment, never left in history. */
export function AuthCallback() {
  const navigate = useNavigate();
  const { refresh, signOut } = useSession();
  const { t } = useTranslation();

  useEffect(() => {
    const parsed = parseAuthFragment(window.location.hash);
    try {
      window.history.replaceState(null, '', window.location.pathname);
    } catch {
      /* ignore */
    }
    if (parsed.type === 'tokens') {
      storeTokens(parsed);
      void refresh().then(async (phase) => {
        if (phase === 'not-staff') {
          await signOut();
          navigate('/login', { replace: true, state: { ssoError: 'staff_only' } });
        } else {
          navigate(parsed.return_to, { replace: true });
        }
      });
    } else {
      navigate('/login', { replace: true, state: { ssoError: parsed.type === 'error' ? parsed.error : 'sso_failed' } });
    }
  }, [navigate, refresh, signOut]);

  return <p className="p-8 text-center text-sm text-faint">{t('login.finishing')}</p>;
}
